module.exports = __webpack_public_path__ + "static/media/AnimationsBad.6fbee772.mov";